import { format } from 'date-fns';
import { REGULAR_DATE_FORMAT } from '@/const';

// Utility function to prepare default values
export const prepareDefaultValues = (row: any) => ({
  workOrderId: row.workOrderId || '-',
  orderType: row.orderType || '-',
  actualWorkDescription: row.description || '-',
  equipmentNumber: row.equipmentNumber || '-',
  componentName: row.clientComponentName || '-',
  maintenanceActivityType: row.maintenanceActivityType || '-',
  actualStartDate: row.actualStartDate ? format(new Date(row.actualStartDate), REGULAR_DATE_FORMAT) : '',
  actualEndDate: row.actualEndDate ? format(new Date(row.actualEndDate), REGULAR_DATE_FORMAT) : '',
  laborHours: row.laborHours.toString() || '-',
  personResponsible: row.personResponsible || '-',
  priority: row.priority || '-',
  plantNumber: row.plantNumber || '-',
  comments: row.razorComment || ' ',
  component: row.componentUiName || 'Select Razor Component',
});
